import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
import { getIconColor } from '../utils/get-icon-color';
const IcoStarFilled16 = t0 => {
  const $ = _c(9);
  const {
    "aria-label": ariaLabel,
    className,
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = getIconColor(color);
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconColor = t1;
  let t2;
  if ($[2] !== iconColor) {
    t2 = <g><path d="M7.6998 2.0186C7.82047 1.76711 8.17953 1.76711 8.3002 2.0186L10.0126 5.5882C10.0612 5.68945 10.1578 5.75935 10.2694 5.77398L14.2103 6.29069C14.488 6.32711 14.5991 6.66852 14.3957 6.86057L11.5139 9.58165C11.4319 9.65899 11.3949 9.77245 11.4155 9.88312L12.1391 13.7702C12.1902 14.0445 11.8996 14.2553 11.6535 14.1225L8.1584 12.2357C8.0596 12.1823 7.9404 12.1823 7.8416 12.2357L4.34646 14.1225C4.10042 14.2553 3.80982 14.0445 3.86088 13.7702L4.5845 9.88312C4.60509 9.77245 4.56807 9.65899 4.48613 9.58165L1.60434 6.86057C1.40095 6.66852 1.51202 6.32711 1.78975 6.29069L5.7306 5.77398C5.8422 5.75935 5.93882 5.68945 5.98739 5.5882L7.6998 2.0186Z" fill={iconColor} stroke={iconColor} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" /></g>;
    $[2] = iconColor;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <defs />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== ariaLabel || $[6] !== className || $[7] !== t2) {
    t4 = <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={false}>{t2}{t3}</svg>;
    $[5] = ariaLabel;
    $[6] = className;
    $[7] = t2;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
export default IcoStarFilled16;